module Steps.Step3.Editability where

import Common

import Widgets.Form (FormState, formFieldPaths)
import Widgets.Form.Access (canUpdate, resolveFieldAccess)


data LockedBanner
    = EditablePrivileged
    | EditableUnprivileged
    | UneditablePrivileged
    | UneditableUnprivileged

derive instance eqLockedBanner :: Eq LockedBanner
derive instance ordLockedBanner :: Ord LockedBanner

type Step3Editability =
    { hasEditableFields :: Boolean
    , lockedBanner :: Maybe LockedBanner
    }

step3Editability :: forall lock. Boolean -> Maybe lock -> FormState -> Step3Editability
step3Editability canLock lockedAt form =
    { hasEditableFields
    , lockedBanner
    }
  where
    hasEditableFields = any isMutableField $ formFieldPaths form

    isMutableField path = canUpdate $ resolveFieldAccess form.access path

    lockedBanner = case lockedAt of
        Nothing -> Nothing
        Just _ -> Just $
            if canLock
            then if hasEditableFields
                then EditablePrivileged
                else UneditablePrivileged
            else if hasEditableFields
                then EditableUnprivileged
                else UneditableUnprivileged
